import React, { useState, useEffect, useMemo } from 'react'
import { Body } from 'components/Shell/Shell'
import { DumbField } from 'components/Wizard2/Field'
import { TextInput } from 'components/Wizard2/fieldComponents/Form'
import FormCard from 'components/FormCard/FormCard'
import { VERIFY_CERTIFICATE, GET_CONFIGURED_ORDER_SOURCE_TYPES, CERTIFY_ORDER } from 'requests'
import ShieldIcon from '@tecuity/sos-icons/react/shield'
import format from 'date-fns/format'
import './Certificate.scss'
import { RadioInput } from '../Wizard2/fieldComponents/Form'
import { SelectBox } from '@tecuity/granite-ui'
import Markdown from 'components/Markdown/Markdown'
import { useSelector, shallowEqual } from 'react-redux'

export class VerifyCertificateOld extends React.Component {
  state = {
    certificateId: '',
    errors: {},
    certificate: null,
    certError: null,
    category: 'business',
  }
  setCertificateId = (certificateId) => {
    this.setState({ certificateId })
  }
  checkEnter = (e) => {
    if (e.charCode === 13) {
      this.validate()
    }
  }
  validate = () => {
    if (this.state.certificateId === '') {
      this.setState({
        errors: {
          certificateId:
            process.env.CERTIFICATE_VERIFICATION_ERROR || 'A certificate ID is required',
        },
      })
    } else {
      this.setState({ errors: { certificateId: '' } })
      this.verifyCertificate(this.state.certificateId)
    }
  }
  verifyCertificate = (certificateId) => {
    this.setState({ certError: null })
    VERIFY_CERTIFICATE(
      certificateId,
      process.env.COMBINED_CERTIFICATE_VERIFICATION ? this.state.category : '',
      (certificate) => {
        this.setState({ certificate })
      },
      (err) => {
        if (err.code === 'certification/certificateNotValid') {
          this.setState({ certError: err.message, certificate: null })
        }
      }
    )
  }
  render() {
    return (
      <Body className="flex-center-page verify-certificate">
        <FormCard
          seal
          title={process.env.CERTIFICATE_VERIFICATION_TITLE || 'Verify Certificate'}
          leftColumn={
            <React.Fragment>
              <DumbField
                label={process.env.CERTIFICATE_VERIFICATION_LABEL || 'Certificate ID'}
                errorMessage={
                  this.state.errors.certificateId ? [this.state.errors.certificateId] : []
                }
              >
                <TextInput
                  value={this.state.certificateId}
                  onChange={this.setCertificateId}
                  onKeyPress={this.checkEnter}
                />
              </DumbField>
              {process.env.COMBINED_CERTIFICATE_VERIFICATION ? (
                <DumbField label="Select a Certificate Type" ownsLabel>
                  <RadioInput
                    value={this.state.category}
                    onChange={(value) => {
                      this.setState({ category: value })
                    }}
                    options={[
                      { value: 'business', label: 'Business' },
                      { value: 'ucc', label: 'UCC' },
                    ]}
                    label="Select a Certificate Type"
                    ownsLabel
                  />
                </DumbField>
              ) : null}
              <button className="btn btn-primary btn-raised" onClick={this.validate}>
                Verify Certificate
              </button>
            </React.Fragment>
          }
          rightColumn={
            <React.Fragment>
              {this.state.certificate ? null : (
                <p className="description">
                  {process.env.CERTIFICATE_VERIFICATION_DESCR ||
                    'To verify a certificate, input the certificate ID found in the bottom left corner of your certificate.'}
                </p>
              )}
              {this.state.certError && (
                <p className="description danger-text">{this.state.certError}</p>
              )}
              {this.state.certificate && (
                <CertificateOld
                  certificate={this.state.certificate}
                  searchRoute={this.searchRoute}
                />
              )}
            </React.Fragment>
          }
        />
      </Body>
    )
  }
}

const CertificateOld = ({
  certificate: {
    CERTIFICATION_TYPE_DESCR,
    COPIES_FILING_DESCR,
    FILING_NUM,
    FILING_DATE,
    DISPLAY_TYPE,
    DETAIL_LIST = [],
    COMMENT,
  },
}) => (
  <div className="certificate-success">
    <p className="description message">
      <ShieldIcon /> This certificate has been verified.
    </p>
    {DISPLAY_TYPE === 'DETAIL_LIST' ? (
      <div>
        <table className="verify-certificate-table">
          <tbody>
            {DETAIL_LIST.map((detail, i) => (
              <tr key={i}>
                <td className="label">
                  <strong>{detail.label}:</strong>
                </td>
                <td className="value">{detail.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <br />
        {COMMENT && <Markdown className="description" source={COMMENT} />}
      </div>
    ) : (
      <React.Fragment>
        <span className="num">{FILING_NUM} - </span>
        <span className="date">{format(new Date(FILING_DATE), 'MM/dd/yyyy')}</span>
        <p>{CERTIFICATION_TYPE_DESCR}</p>
        <p>{COPIES_FILING_DESCR}</p>
      </React.Fragment>
    )}
  </div>
)

const VerifyCertificate = () => {
  const [certificateId, setCertificateId] = useState('')
  const [errors, setErrors] = useState({})
  const [certificate, setCertificate] = useState(null)
  const [certError, setCertError] = useState(null)
  const [sourceType, setSourceType] = useState('54') // business default
  const [sourceTypeOptions, setSourceTypeOptions] = useState([])
  const {
    CertificateVerificationError = '',
    CertificateVerificationTitle = '',
    CertificateVerificationLabel = '',
    CertificateVerificationDescription = '',
  } = useSelector((state) => state.app.appSettings, shallowEqual)

  useEffect(() => {
    GET_CONFIGURED_ORDER_SOURCE_TYPES(
      true,
      (types) => {
        const filterTypes = types.filter((t) => t.Id !== 0)
        setSourceTypeOptions(
          filterTypes.map((type) => ({
            label: type.ModuleName,
            value: type.Id,
          }))
        )
        if (filterTypes.length > 0) setSourceType(filterTypes[0].Id.toString())
      },
      (err) => console.error(err)
    )
  }, [])

  const validate = () => {
    if (certificateId === '') {
      setErrors({
        certificateId: CertificateVerificationError || 'A certificate ID is required',
      })
    } else {
      setErrors({ certificateId: '' })
      certifyOrder(certificateId)
    }
  }

  const certifyOrder = (certificateId) => {
    setCertError(null)
    CERTIFY_ORDER(
      sourceType,
      certificateId,
      (certificate) => {
        setCertificate(certificate)
      },
      (err) => {
        if (typeof err === 'string') setCertError(err)
        setCertificate(null)
      }
    )
  }

  return (
    <Body className="flex-center-page verify-certificate">
      <FormCard
        seal
        title={CertificateVerificationTitle || 'Verify Certificate'}
        leftColumn={
          <React.Fragment>
            <DumbField
              label={CertificateVerificationLabel || 'Certificate ID'}
              errorMessage={errors.certificateId ? [errors.certificateId] : []}
            >
              <TextInput
                value={certificateId}
                onChange={setCertificateId}
                onKeyPress={(e) => {
                  if (e.charCode === 13) {
                    validate()
                  }
                }}
              />
            </DumbField>

            <DumbField label="Select a Certificate Type">
              <SelectBox
                aria-label="Select a Certificate Type"
                noPlaceholder
                value={sourceType}
                onChange={setSourceType}
                options={sourceTypeOptions}
              />
            </DumbField>

            <button className="btn btn-primary btn-raised" onClick={validate}>
              Verify Certificate
            </button>
          </React.Fragment>
        }
        rightColumn={
          <React.Fragment>
            {certificate ? null : (
              <p className="description">
                {CertificateVerificationDescription ||
                  'To verify a certificate, input the certificate ID found in the bottom left corner of your certificate.'}
              </p>
            )}
            {certError && <p className="description danger-text">{certError}</p>}
            {certificate && <Certificate certificate={certificate} />}
          </React.Fragment>
        }
      />
    </Body>
  )
}
export default VerifyCertificate

const Certificate = ({ certificate }) => {
  const { Header = '', SubHeader = '', Sections = {} } = certificate

  const detailList = useMemo(() => {
    const list = []
    for (let [key, value] of Object.entries(Sections)) {
      // console.log(key, value)
      list.push({ label: key, value })
    }
    return list
  }, [Sections])

  return (
    <div className="certificate-success">
      <p className="description message">
        <ShieldIcon /> This certificate has been verified.
      </p>
      <span className="num">{Header} - </span>
      <span className="date">{SubHeader}</span>
      <div>
        <table className="verify-certificate-table">
          <tbody>
            {detailList.length > 0 &&
              detailList.map((detail, i) => (
                <tr key={i}>
                  <td className="label">
                    <strong>{detail.label}:</strong>
                  </td>
                  <td className="value">{detail.value}</td>
                </tr>
              ))}
          </tbody>
        </table>
        <br />
        {/* {COMMENT && <Markdown className="description" source={COMMENT} />} */}
      </div>

      {/* : (
        <React.Fragment>
          <span className="num">{FILING_NUM} - </span>
          <span className="date">{format(new Date(FILING_DATE), 'MM/dd/yyyy')}</span>
          <p>{CERTIFICATION_TYPE_DESCR}</p>
          <p>{COPIES_FILING_DESCR}</p>
        </React.Fragment>
      )} */}
    </div>
  )
}
